/*!
 * Copyright © 2019-2021. Verizon Connect Ireland Limited. All rights reserved.
 */

import { EventEmitter, Input, Output } from '@angular/core';
import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fm-ghost-element-loader-image',
  templateUrl: './ghost-element-loader-image.component.html',
  styleUrls: ['./ghost-element-loader-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GhostElementLoaderImageComponent {
  @Input()
  src: string;
  @Input()
  alt: string;

  @Output()
  loaded = new EventEmitter<void>();

  imageLoaded: boolean;

  onImageLoad(_: any): void {
    this.imageLoaded = true;
    this.loaded.emit();
  }
}
